export const markerRules = {
    EmphasisMark: {
        ownerNames: ["StrongEmphasis", "Emphasis"],
        isSourceMarker: true
    },
    CodeMark: {
        ownerNames: ["InlineCode", "FencedCode"],
        isSourceMarker: true
    },
    CodeInfo: {
        ownerNames: ["FencedCode"]
    },
    HeaderMark: {
        ownerNames: [
            "ATXHeading1",
            "ATXHeading2",
            "ATXHeading3",
            "ATXHeading4",
            "ATXHeading5",
            "ATXHeading6"
        ],
        isSourceMarker: true,
        consumesSeparator: true
    },
    QuoteMark: {
        ownerNames: ["Blockquote"],
        isSourceMarker: true,
        consumesSeparator: true,
        replacementResolver: () => "| "
    },
    ListMark: {
        ownerNames: ["ListItem"],
        isSourceMarker: true,
        consumesSeparator: true,
        replacementResolver: (sourceMarker) => {
            const marker = sourceMarker.trim();
            return /^\d/.test(marker) ? `${marker} ` : "- ";
        }
    },
    LinkMark: {
        ownerNames: ["Link", "Autolink", "Image"],
        isSourceMarker: true
    },
    URL: {
        ownerNames: ["Link", "Image"]
    },
    LinkTitle: {
        ownerNames: ["Link", "Image"]
    },
    LinkLabel: {
        ownerNames: ["Link"]
    }
};
